"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphGrid_1 = require("./graph/graphGrid");
const NameVertex_1 = require("./graph/vertices/NameVertex");
class GraphRandom {
    static generateGraph(igraph, isPathExercise) {
        igraph.resetGraph();
        NameVertex_1.NameVertex.resetNames();
        switch (this.ind) {
            case 0:
                this.graph1(igraph);
                break;
            case 1:
                this.graph2(igraph);
                break;
            case 2:
                this.graph3(igraph);
                break;
            case 3:
                this.graph4(igraph);
                break;
            case 4:
                this.graph5(igraph);
                break;
            case 5:
                this.graph6(igraph);
                break;
        }
        this.ind = (this.ind + 1) % this.count;
        if (isPathExercise) {
            let nodes = igraph.getGraph().getNodes();
            igraph.setSourceNode(nodes[0]);
            igraph.setTargetNode(nodes[nodes.length - 1]);
        }
        igraph.forceUpdate();
    }
    static graph1(igraph) {
        let nodes = [igraph.newNode(), igraph.newNode(),
            igraph.newNode(), igraph.newNode(), igraph.newNode()];
        let coords = [[4, 4], [2.5, 6], [5.5, 6], [4, 8], [4, 10]];
        let grid = igraph.getGrid();
        if (grid instanceof graphGrid_1.GraphGrid) {
            for (let i = 0; i < nodes.length; i++) {
                igraph.add(nodes[i], grid.convertCoordinateToRaw([coords[i][0], coords[i][1]]));
            }
        }
        igraph.add(igraph.newEdge(nodes[0], nodes[1]));
        igraph.add(igraph.newEdge(nodes[0], nodes[2]));
        igraph.add(igraph.newEdge(nodes[1], nodes[3]));
        igraph.add(igraph.newEdge(nodes[2], nodes[3]));
        igraph.add(igraph.newEdge(nodes[3], nodes[4]));
    }
    static graph2(igraph) {
        let nodes = [igraph.newNode(), igraph.newNode(),
            igraph.newNode(), igraph.newNode(), igraph.newNode(), igraph.newNode()];
        let coords = [[2, 5], [4, 5], [6, 5], [2, 9], [4, 9], [6, 9]];
        let grid = igraph.getGrid();
        if (grid instanceof graphGrid_1.GraphGrid) {
            for (let i = 0; i < nodes.length; i++) {
                igraph.add(nodes[i], grid.convertCoordinateToRaw([coords[i][0], coords[i][1]]));
            }
        }
        igraph.add(igraph.newEdge(nodes[0], nodes[3]));
        igraph.add(igraph.newEdge(nodes[0], nodes[4]));
        igraph.add(igraph.newEdge(nodes[1], nodes[4]));
        igraph.add(igraph.newEdge(nodes[1], nodes[5]));
        igraph.add(igraph.newEdge(nodes[2], nodes[5]));
    }
    static graph3(igraph) {
        let nodes = [igraph.newNode(), igraph.newNode(),
            igraph.newNode(), igraph.newNode(), igraph.newNode(), igraph.newNode()];
        let coords = [[2, 5], [2, 7], [2, 9], [4, 7], [4, 9], [6, 9]];
        let grid = igraph.getGrid();
        if (grid instanceof graphGrid_1.GraphGrid) {
            for (let i = 0; i < nodes.length; i++) {
                igraph.add(nodes[i], grid.convertCoordinateToRaw([coords[i][0], coords[i][1]]));
            }
        }
        igraph.add(igraph.newEdge(nodes[0], nodes[1]));
        igraph.add(igraph.newEdge(nodes[0], nodes[3]));
        igraph.add(igraph.newEdge(nodes[1], nodes[2]));
        igraph.add(igraph.newEdge(nodes[2], nodes[4]));
        igraph.add(igraph.newEdge(nodes[3], nodes[5]));
        igraph.add(igraph.newEdge(nodes[1], nodes[3]));
        igraph.add(igraph.newEdge(nodes[3], nodes[4]));
        igraph.add(igraph.newEdge(nodes[4], nodes[5]));
        igraph.add(igraph.newEdge(nodes[4], nodes[5]));
    }
    static graph4(igraph) {
        let nodes = [igraph.newNode(), igraph.newNode(),
            igraph.newNode(), igraph.newNode(), igraph.newNode(),
            igraph.newNode(), igraph.newNode(), igraph.newNode()];
        let coords = [[3, 4], [3, 6], [3, 8], [3, 10],
            [5, 4], [5, 6], [5, 8], [5, 10]];
        let grid = igraph.getGrid();
        if (grid instanceof graphGrid_1.GraphGrid) {
            for (let i = 0; i < nodes.length; i++) {
                igraph.add(nodes[i], grid.convertCoordinateToRaw([coords[i][0], coords[i][1]]));
            }
        }
        igraph.add(igraph.newEdge(nodes[0], nodes[1]));
        igraph.add(igraph.newEdge(nodes[0], nodes[4]));
        igraph.add(igraph.newEdge(nodes[1], nodes[2]));
        igraph.add(igraph.newEdge(nodes[1], nodes[5]));
        igraph.add(igraph.newEdge(nodes[2], nodes[3]));
        igraph.add(igraph.newEdge(nodes[2], nodes[6]));
        igraph.add(igraph.newEdge(nodes[3], nodes[7]));
        igraph.add(igraph.newEdge(nodes[4], nodes[5]));
        igraph.add(igraph.newEdge(nodes[5], nodes[6]));
        igraph.add(igraph.newEdge(nodes[6], nodes[7]));
    }
    static graph5(igraph) {
        let nodes = [igraph.newNode(), igraph.newNode(), igraph.newNode(),
            igraph.newNode(), igraph.newNode(), igraph.newNode(),
            igraph.newNode(), igraph.newNode(), igraph.newNode()];
        let coords = [[2, 5], [2, 7], [2, 9],
            [4, 5], [4, 7], [4, 9],
            [6, 5], [6, 7], [6, 9]];
        let grid = igraph.getGrid();
        if (grid instanceof graphGrid_1.GraphGrid) {
            for (let i = 0; i < nodes.length; i++) {
                igraph.add(nodes[i], grid.convertCoordinateToRaw([coords[i][0], coords[i][1]]));
            }
        }
        igraph.add(igraph.newEdge(nodes[0], nodes[1]));
        igraph.add(igraph.newEdge(nodes[1], nodes[2]));
        igraph.add(igraph.newEdge(nodes[0], nodes[3]));
        igraph.add(igraph.newEdge(nodes[3], nodes[4]));
        igraph.add(igraph.newEdge(nodes[4], nodes[5]));
        igraph.add(igraph.newEdge(nodes[3], nodes[6]));
        igraph.add(igraph.newEdge(nodes[6], nodes[7]));
        igraph.add(igraph.newEdge(nodes[2], nodes[5]));
        igraph.add(igraph.newEdge(nodes[5], nodes[8]));
        igraph.add(igraph.newEdge(nodes[7], nodes[8]));
    }
    static graph6(igraph) {
    }
}
exports.GraphRandom = GraphRandom;
GraphRandom.ind = 0;
GraphRandom.count = 5;
